import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import resetPasswordReducer from "./reset-password";
import confirmCodeReducer from "./confirm-code";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    resetPassword: resetPasswordReducer,
    confirmCode: confirmCodeReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
